import { FormInputIngredientsItem } from 'Components/FormInputIngredients/IngredientAmountInput'
import { ReduxRecipe, ReduxRecipeAddData } from 'Models'
import { mapEatableSourceToFormValue } from 'Utils/helpers/mapEatableSourceToFormValue'

export type RecipeFormValuesType = Omit<ReduxRecipeAddData, 'ingredients'> & {
  ingredients: FormInputIngredientsItem[]
}

export const mapValuesToRecipeData = (values: RecipeFormValuesType): ReduxRecipeAddData => {
  const { ingredients, ...recipeData } = values
  return {
    ...recipeData,
    ingredients: ingredients.map((ingredient, index) => ({
      foodId: ingredient.food.id,
      position: index,
      ...ingredient.amount
    }))
  }
}

export const mapReduxRecipeToFormValues = (data: ReduxRecipe): RecipeFormValuesType => {
  const { ingredients, sourceId, source, ...recipeData } = data
  return {
    ...recipeData,
    ingredients: ingredients.map(({ food, quantity, unit }) => ({
      food,
      amount: {
        quantity,
        unit
      }
    })),
    source: mapEatableSourceToFormValue(source, undefined)
  }
}
